<template>
  <v-container>
    <v-card
      :loading="false"
    >
      <v-overlay
        :absolute="true"
        :value="isComponentLoading"
      >
        <v-progress-circular indeterminate size="24"></v-progress-circular>
      </v-overlay>
      <v-row class="pa-3">
        <v-col cols="12" md="6">
          <manager-selector
            :selected-cleaner="searchParams.manager"
            @select="searchParams.manager = $event"
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-menu
            v-model="menuFrom"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="fromDateFormatted"
                @input="changeDate('from', $event)"
                :label="$t('general.date')"
                prepend-icon="mdi-calendar"
                readonly
                clearable
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="searchParams.from" no-title
                           :first-day-of-week="1"
                           :locale="getCurrentLanguage()"
                           @input="menuFrom = false"></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import { MANAGER_TOP } from '@/constants/roles';

/* mixins */
import isComponentLoading from '@/mixins/isComponentLoading';
import regionsFilter from '@/mixins/filters/regionsFilter';
import payedFilter from '@/mixins/filters/payedFilter';
import searchTextFilter from '@/mixins/filters/searchTextFilter';
import searchCleanerFilter from '@/mixins/filters/searchCleanerFilter';
import ManagerSelector from '@/components/autocomples/ManagerSelector.vue';

export default {
  name: 'FilterDailyReport',
  mixins: [
    isComponentLoading,
    regionsFilter,
    payedFilter,
    searchTextFilter,
    searchCleanerFilter,
  ],
  components: {
    ManagerSelector,
  },
  props: {
    defaultSearchParams: {
      type: Object,
      default: () => ({
        manager: null,
        from: '2020-10-25',
      }),
    },
  },
  data() {
    return {
      MANAGER_TOP,
      useNullableNegativeStatus: false,
      searchParams: {},
      menuFrom: false,
      menuTo: false,
    };
  },
  mounted() {
    this.searchParams = Object.assign({
      manager: null,
      from: null,
    }, this.defaultSearchParams);
  },
  computed: {
    account() {
      return this.$store.getters['account/account'];
    },
    fromDateFormatted() {
      return this.formatDate(this.searchParams.from);
    },
  },
  watch: {
    searchParams: {
      handler(newVal) {
        this.$emit('filtering', newVal);
      },
      deep: true,
    },
  },
  methods: {
    getCurrentLanguage() {
      return localStorage.getItem('language') || process.env.VUE_APP_DEFAULT_LANGUAGE;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    changeDate(type, date) {
      if (date === null) {
        this.searchParams[type] = null;
      }
    },
  },
};
</script>

<style scoped>

</style>
